import type { Provider } from "../providers/provider";
import type { DailySchedule } from "./daily-schedule";
import { getDailySchedulesForWeekday } from "./get-daily-schedules-for-weekday";

const getDailySchedulesForWeekdayAndProvider = (
    day: Date, //| WeekdayShortName,
    provider: Provider,
): DailySchedule[] => {
    const exceptions = provider.options.businessHourExceptions;

    const dailySchedules = getDailySchedulesForWeekday(
        day,
        provider.options.businessHours,
        exceptions,
    );

    return dailySchedules;
};

export { getDailySchedulesForWeekdayAndProvider };
